/**
 * Movement Cost — momentum cost and speed scaling based on terrain slope.
 * Pure function shared between human and future AI movement.
 */

import { MOMENTUM, MOVEMENT } from '../constants';

export interface MoveCost {
  cost: number;
  speedMult: number;
}

export function calculateMoveCost(rise: number): MoveCost {
  if (rise <= 0) {
    // Downhill or flat — discounted cost, full speed
    return { cost: MOMENTUM.FLAT_COST_PER_FRAME * MOMENTUM.DOWNHILL_COST_MULT, speedMult: 1 };
  }
  const slopeFactor = Math.min(rise / MOVEMENT.MAX_CLIMBABLE_RISE, 1);
  const cost = MOMENTUM.FLAT_COST_PER_FRAME * (1 + slopeFactor * (MOMENTUM.UPHILL_COST_MAX - 1));
  const speedMult = 1 - slopeFactor * (1 - MOMENTUM.UPHILL_SPEED_PENALTY);
  return { cost, speedMult };
}
